import { useContext, useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, TextField, DialogContentText, Grid } from '@mui/material';
import { Autocomplete } from 'components';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';
import { ticketDetailsContext } from 'views/TicketDetails/TicketDetailsContext';

interface IProps {
    partialTicket: IPartialTicket

    onClose: (reloadTicket: boolean) => void
}

interface IPartialTicket {
    ticketId: string
    title: string
    customerId: number
    customerName: string
    countryCode: string
    countryName: string
    reporter: string
}

let EditTicket = ({ partialTicket, onClose }: IProps) => {
    let { enqueueSnackbar } = useSnackbar();
    let { formatMessage } = useIntl();
    let service = useContext(ticketDetailsContext);

    let [isSaving, setSaving] = useState<boolean>(false);
    let [ticket, setTicket] = useState<IPartialTicket>({} as IPartialTicket);

    useEffect(() => {
        setTicket({ ...partialTicket })
    }, [partialTicket]);


    let searchCustomers = async (searchText: string, etag: number) => {
        if (!searchText)
            return;

        try {

            let request = {
                searchText: searchText,
                etag: etag
            };

            const res = await axios.post('/api/Order/CustomersQuickSearch', request);
            return res.data;
        } catch { }
    }

    let updateTicket = (newTicket: IPartialTicket) => {
        setTicket({ ...newTicket });
    }


    let closeAndConfirm = async () => {
        try {
            setSaving(true);

            let request = {
                ...ticket
            }

            let res = await axios.post('/api/Ticket/UpdateTicketTitleCustomer', request);

            if (res.data.affectedRecords === 1) {
                enqueueSnackbar(formatMessage({ id: LocalizationIds.TicketSaved }), { variant: "success" });
                onClose(true);
            }
        } catch (err) { }
        finally {
            setSaving(false);
        }
    }


    return (
        <Dialog open={true} onClose={() => onClose(false)} fullWidth>
            <DialogTitle>
                {formatMessage({ id: LocalizationIds.EditTicketDetails })}
            </DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item xs={12}>
                        <TextField
                            label={formatMessage({ id: LocalizationIds.Title })}
                            id="search text"
                            name="title"
                            value={ticket.title}
                            onChange={e => updateTicket({
                                ...ticket,
                                title: e.target.value
                            })}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            inputLabel={formatMessage({ id: LocalizationIds.Customer })}
                            value={{
                                value: ticket.customerId,
                                label: ticket.customerName
                            }}
                            disabled={service.reporters.getValueByKey(ticket.reporter, 'value', 'isExternal') === true}
                            doSearch={(value: string, etag: number) => searchCustomers(value, etag)}
                            onChange={(value: any) => {
                                updateTicket({
                                    ...ticket,
                                    customerId: value?.value || 0,
                                    customerName: value?.customerName || '',
                                    countryCode: value?.countryCode || '',
                                    countryName: value?.countryName || ''
                                })
                            }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <DialogContentText>
                            <Typography color="textSecondary">{formatMessage({ id: LocalizationIds.INFO_ChangeCustomersOrders })}</Typography>
                        </DialogContentText>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={() => onClose(false)} color="secondary" autoFocus>
                    {formatMessage({ id: LocalizationIds.Cancel })}
                </Button>
                <Button
                    onClick={() => closeAndConfirm()}
                    disabled={isSaving === true || ticket.customerId === 0 || ticket.title?.length <= 0}
                    autoFocus
                >
                    {formatMessage({ id: LocalizationIds.Confirm })}

                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default EditTicket;


